import { Text } from 'ui/components/Text'
import { FC, ReactNode } from 'react'

interface Props {
  button?: ReactNode
  children?: ReactNode
  title: ReactNode
}

export const Section: FC<Props> = ({ title, button, children }) => (
  <div>
    <div className="flex justify-between items-center p-3">
      <Text type="title3">{title}</Text>
      {button}
    </div>

    {children}
  </div>
)
